import Dashboard from '@/modules/dashboard/components/Main.vue'
import bus from '@/utils/events/bus'

export default {
    data () {
        return {
            goBackTo: '/'
        }
    },
    beforeRouteEnter (to, from, next) {
        if (!from.matched.length)
            to.matched[0].components.default = Dashboard
        else
            to.matched[0].components.default = from.matched[0].components.default

        next(vm => {
            vm.fetchRecords()
            vm.goBackTo = from.path
        })
    },
    beforeRouteLeave (to, from, next) {
        setTimeout(() => { next() }, 200)
    },
    created () {
        bus.$on('goBack', () => this.goBack())
        document.addEventListener('keyup', this.escapeKeyListener)
    },
    beforeDestroy () {
        bus.$off('goBack')
        document.removeEventListener('keyup', this.escapeKeyListener)
    },
    methods: {
        goBack () {
            this.$router.push(this.goBackTo)
        },
        escapeKeyListener (evt) {
            if (evt.keyCode === 27)
                this.goBack()
        },
        fetchRecords () {
            // Do list request
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/mixins/routed-modals.js